var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.26,
    y: 0.366943,
    width: 56,
    height: 54.5228,
    rx: 12,
    fill: "#EB966A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6668 11.4014H16.3335C13.5768 11.4014 11.3335 13.5855 11.3335 16.2695V20.8633C11.3335 22.572 11.9702 24.125 13.0002 25.3193V40.61C13.0002 41.0404 13.1758 41.4531 13.4883 41.7574C13.8009 42.0617 14.2248 42.2327 14.6668 42.2327H28.0002C28.4422 42.2327 28.8661 42.0617 29.1787 41.7574C29.4912 41.4531 29.6668 41.0404 29.6668 40.61V32.4965H36.3335V40.61C36.3335 41.0404 36.5091 41.4531 36.8216 41.7574C37.1342 42.0617 37.5581 42.2327 38.0002 42.2327H41.3335C41.7755 42.2327 42.1994 42.0617 42.512 41.7574C42.8246 41.4531 43.0002 41.0404 43.0002 40.61V25.3177C44.0302 24.125 44.6668 22.572 44.6668 20.8617V16.2695C44.6668 13.5855 42.4235 11.4014 39.6668 11.4014ZM41.3335 16.2695V20.8633C41.3335 22.7132 39.9185 24.2905 38.1818 24.3797L38.0002 24.383C36.1618 24.383 34.6668 22.9274 34.6668 21.1376V14.6468H39.6668C40.5868 14.6468 41.3335 15.3754 41.3335 16.2695ZM24.6668 21.1376V14.6468H31.3335V21.1376C31.3335 22.9274 29.8385 24.383 28.0002 24.383C26.1618 24.383 24.6668 22.9274 24.6668 21.1376ZM14.6668 16.2695C14.6668 15.3754 15.4135 14.6468 16.3335 14.6468H21.3335V21.1376C21.3335 22.9274 19.8385 24.383 18.0002 24.383L17.8185 24.3781C16.0818 24.2905 14.6668 22.7132 14.6668 20.8633V16.2695ZM24.6668 34.1192H18.0002V29.2511H24.6668V34.1192Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28.0002,
    y1: 11.4014,
    x2: 28.0002,
    y2: 42.2327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA9769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA6969"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3f5fb8be.svg";
export { ForwardRef as ReactComponent };